module.exports = __webpack_public_path__ + "img/PropertyFieldTypes.65ed47fc.svg";